import { usePdfViewerInteractionContext } from "@/src/components/pdf-viewer/interaction-provider";
import { Label } from "@/src/components/shadcn/ui/label";
import { Select, SelectTrigger, SelectValue } from "@/src/components/shadcn/ui/select";
import { SelectWrapper } from "@/src/components/tasks/input-wrapper";
import { useServiceLines } from "@/src/lib/data-fetchers/service-lines-fetchers";

interface ServiceLineSelectorProps {
  value: string | undefined | null;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  isRequired?: boolean;
  onFlagForInaccuracyUpdate?: (key: string, value: any) => void;
  fieldKey?: string;
  metadata?: any;
  disabled?: boolean;
}

export default function ServiceLineSelector({
  value,
  onChange,
  label = "Service Line",
  placeholder,
  isRequired = false,
  onFlagForInaccuracyUpdate,
  fieldKey = "serviceLine",
  metadata,
  disabled = false,
}: ServiceLineSelectorProps) {
  const { setMetadata, clearMetadata } = usePdfViewerInteractionContext();
  const { data: serviceLineOptions, isPending, isError, error } = useServiceLines();

  if (isPending) {
    return (
      <div className="px-1">
        <div className="mb-2">
          {label && (
            <div className="flex items-center justify-between">
              <Label className="text-muted-foreground">{label}</Label>
            </div>
          )}
        </div>
        <Select disabled>
          <SelectTrigger className="bg-input">
            <SelectValue placeholder="Loading service lines..." />
          </SelectTrigger>
        </Select>
      </div>
    );
  }

  if (isError || serviceLineOptions == null) {
    const errorMessage = error instanceof Error ? error.message : "Failed to fetch service lines";

    return (
      <div className="px-1">
        <div className="mb-2">{label && <div className="text-muted-foreground">{label}</div>}</div>
        <div className="bg-input px-3 py-2 rounded-md text-sm text-destructive">Error: {errorMessage}</div>
      </div>
    );
  }

  return (
    <SelectWrapper
      value={value}
      onChange={onChange}
      onFocus={() => setMetadata(metadata?.serviceLine_metadata)}
      onBlur={clearMetadata}
      label={label}
      placeholder={placeholder}
      isRequired={isRequired}
      disabled={disabled}
      options={serviceLineOptions}
      onFlagForInaccuracyUpdate={onFlagForInaccuracyUpdate}
      fieldKey={fieldKey}
    />
  );
}
